import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler, XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {signup_template} from "../components/templates/signup_template";

declare var ko: any;
declare var page: any;

export class signup extends vnModule_knockoutJS{

    protected XHRHdl: XMLHttpRequestHandler;
    protected signup_template: signup_template;

    protected getModuleName(){
        return "signup";
    }

    buildContent() : Array<Element>{

        this.signup_template = new signup_template("signup", this.viewModel, this);
        return [this.signup_template.build()];
    }

    fillPage() : void{

        this.signup_template.initPlans();
        this.signup_template.setTimeZones();
        this.signup_template.getTemplateViewModel().signup("block");

        let urlParams = this.getUrlParmsFromPath();
        if (urlParams['plan'] != undefined) {

            this.signup_template.setPlan(urlParams['plan']);
        }
    }

    public signup(){

        this.loadingIn(this.signup_template.builtTemplate);

        let subViewModel = this.signup_template.getViewModelForRequest();

        let usrReq_url: string = '/api/access/signup/';

        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);
        this.XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;

        this.XHRHdl.onReadyStateFunction = this.onSignupRequestReturn;
        this.XHRHdl.execute();
    }

    protected onSignupRequestReturn(req, obj): Function{

        return function(){

            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);

                obj.signup_template.getTemplateViewModel().signup("none");
                obj.signup_template.getTemplateViewModel().checkout("none");
                obj.signup_template.getTemplateViewModel().emailSent("block");
            });

            if(req.request.readyState == 4){
                if (req.request.status == 200 || req.request.status == 400 || req.request.status == 500) {
                    // LOADING : ends
                    obj.loadingOut(obj.signup_template.builtTemplate);
                }
            }
        }
    }

    public applyPromo(){

        this.loadingIn(this.signup_template.builtTemplate);

        let subViewModel = this.signup_template.getViewModelForRequest();

        let usrReq_url: string = '/api/access/applyPromo/';

        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onApplyPromoReturn;
        this.XHRHdl.execute();
    }

    protected onApplyPromoReturn(req, obj): Function{

        return function(){

            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);
                obj.signup_template.setPromoCodeData(responseParsed.promoCodeData);
            });

            if(req.request.readyState == 4){
                if (req.request.status == 200 || req.request.status == 400 || req.request.status == 500) {
                    // LOADING : ends
                    obj.loadingOut(obj.signup_template.builtTemplate);
                }
            }
        }
    }

    public validateSignup(){

        this.loadingIn(this.signup_template.builtTemplate.querySelector("#signup"));

        let subViewModel = this.signup_template.getViewModelForRequest();

        let usrReq_url: string = '/api/access/validateSignup/';

        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onValidateSignupRequestReturn;
        this.XHRHdl.execute();
    }

    protected onValidateSignupRequestReturn(req, obj): Function{

        return function(){

            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);

                obj.signup_template.initCardElement();
                obj.signup_template.getTemplateViewModel().signup("none");
                obj.signup_template.getTemplateViewModel().billingEmailSameAsAccount(1);
                obj.signup_template.getTemplateViewModel().billingEmail(obj.signup_template.getTemplateViewModel().email());
                obj.signup_template.getTemplateViewModel().checkout("block");
            });

            if(req.request.readyState == 4){
                if (req.request.status == 200 || req.request.status == 400) {
                    // LOADING : ends
                    obj.loadingOut(obj.signup_template.builtTemplate.querySelector("#signup"));
                }
            }
        }
    }


    protected filterSingleGroupSelectorOnChange(id){

        if (id == 'plan') {

            this.signup_template.updatePlanId()
        }

    }
}



// WEBPACK FOOTER //
// ./js/modules/signup.ts